import { useState } from "react";
import { toast } from "sonner";

import {
  ErrorBanner,
  Field,
  Modal,
  PrimaryButton,
  SecondaryButton,
  TextArea,
} from "../crm/Form";
import api, { formatApiError } from "../../lib/api";

/**
 * Phase 5c — owner/ops only.
 * Soft revoke: requires reason (5–500 chars). Idempotent.
 */
export default function AcknowledgmentRevokeModal({
  open,
  onClose,
  reportId,
  ackId,
  onRevoked,
}) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e?.preventDefault?.();
    setBusy(true);
    setErr("");
    try {
      const r = await api.post(
        `/diagnostic-reports/${reportId}/acknowledgments/${ackId}/revoke`,
        { reason: reason.trim() }
      );
      toast.success("Acknowledgment revoked");
      setReason("");
      onClose?.();
      onRevoked?.(r.data);
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Revoke acknowledgment"
      subtitle="Soft revoke · audit-only"
      data-testid="ack-revoke-modal"
    >
      <form onSubmit={submit} className="space-y-4">
        <ErrorBanner message={err} />
        <Field
          label="Reason (required, 5–500 chars)"
          hint="Explain why this acknowledgment should be voided. Visible only to owner/ops."
        >
          <TextArea
            value={reason}
            onChange={setReason}
            rows={3}
            maxLength={500}
            data-testid="ack-revoke-reason"
          />
        </Field>
        <div className="flex justify-end gap-2 pt-2">
          <SecondaryButton type="button" onClick={onClose}>
            Cancel
          </SecondaryButton>
          <PrimaryButton
            type="submit"
            disabled={busy || reason.trim().length < 5}
            data-testid="ack-revoke-submit"
          >
            {busy ? "Revoking…" : "Revoke"}
          </PrimaryButton>
        </div>
      </form>
    </Modal>
  );
}
